export const RV = {
  bg: 'var(--bg)',
  panel: 'var(--panel)',
  panel2: 'var(--panel-2)',
  border: 'var(--border)',
  hairline: 'var(--hairline)',
  controlBorder: 'var(--control-border)',
  text: 'var(--text)',
  text2: 'var(--text-2)',
  text3: 'var(--text-3)',
  brand: 'var(--brand)',
  accent: 'var(--accent)',
  accentText: 'var(--accent-text)',
  ok: 'var(--ok)',
  warn: 'var(--warn)',
  bad: 'var(--bad)',
  note: 'var(--note)',
  fDisplay: 'var(--f-display)',
  fBody: 'var(--f-body)',
  fNum: 'var(--f-num)',

  /* v1 aliases — map onto semantic tokens so existing pages pick up v2 */
  navy: {
    900: 'var(--rail)',
    800: 'var(--brand-hover)',
    700: 'var(--brand)',
    600: 'var(--note)',
    500: 'var(--brand)',
    400: 'var(--note)',
    300: 'var(--rail-text)',
    200: 'var(--note-bd)',
    100: 'var(--note-bg)',
    50: 'var(--panel)',
  },
  orange: {
    900: 'var(--accent-on)',
    800: 'var(--accent-hover)',
    700: 'var(--accent-text)',
    600: 'var(--accent-hover)',
    500: 'var(--accent)',
    400: 'var(--accent-text)',
    300: 'var(--accent-text)',
    200: 'var(--warn-bd)',
    100: 'var(--warn-bg)',
    50: 'var(--panel)',
  },
  ink: {
    950: 'var(--text)',
    900: 'var(--text)',
    800: 'var(--text)',
  },
  slate: {
    700: 'var(--text-2)',
    600: 'var(--text-3)',
    500: 'var(--text-3)',
    400: 'var(--text-3)',
    300: 'var(--control-border)',
    200: 'var(--border)',
    100: 'var(--panel-2)',
    50: 'var(--panel)',
  },
  white: 'var(--bg)',
  success: 'var(--ok)',
  successBg: 'var(--ok-bg)',
  successBorder: 'var(--ok-bd)',
  warning: 'var(--warn)',
  warningBg: 'var(--warn-bg)',
  warningBorder: 'var(--warn-bd)',
  error: 'var(--bad)',
  errorBg: 'var(--bad-bg)',
  errorBorder: 'var(--bad-bd)',
  info: 'var(--note)',
  infoBg: 'var(--note-bg)',
  infoBorder: 'var(--note-bd)',
  chart: ['var(--brand)', 'var(--accent)', 'var(--note)', 'var(--ok)', 'var(--text-3)', 'var(--warn)'],
  radius: {
    sm: 'var(--r-structure)',
    md: 'var(--r-structure)',
    lg: 'var(--r-structure)',
    full: 'var(--r-tag)',
  },
  elev: {
    1: 'none',
    2: 'none',
    3: 'var(--shadow-pop)',
  },
  sidebar: 'var(--rail-w)',
  topbar: 'auto',
  fontDisplay: 'var(--f-display)',
  fontBody: 'var(--f-body)',
  fontMono: 'var(--f-num)',
};

export const rvPrimaryBtn = { variant: 'rvSolid' };
export const rvAccentBtn = { variant: 'rvAccent' };
export const rvSecondaryBtn = { variant: 'rvQuiet' };
export const rvSolid = { variant: 'rvSolid' };
export const rvQuiet = { variant: 'rvQuiet' };

export const rvCard = {
  bg: 'var(--panel)',
  border: '1px solid',
  borderColor: 'var(--border)',
  borderRadius: 'var(--r-structure)',
  boxShadow: 'none',
};
